module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weekpass"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-vertical is-8"
  }, _vm._l((_vm.href.iframes), function(frame) {
    return _c('div', {
      staticClass: "column contains-iframe-to-center"
    }, [_c('ImageFrame', {
      key: frame,
      attrs: {
        "url": frame
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tile is-child is-parent"
  }, [_c('Offer', {
    attrs: {
      "rangeStart": "0",
      "rangeEnd": "1"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-695ca5a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WeekPass.vue
// module id = 251
// module chunks = 5